<template>
  <div class="results articles-container">

    <!-- <h2 v-if="searchString">results for {{searchString}}</h2> -->
      <div v-if="events" class="events">

        <Event 
          v-for="(event, index) in events"
          :index="index"
          :key="`${event.metaData.assetId} - ${index} index`"
          :event="event"
        />
        
      </div>

  </div>
</template>

<script>
import Event from './Event.vue'
var dayjs = require('dayjs')

export default {
  name: 'Events',
  props: ['events', 'searchString'],
  components:{
    Event
  },
  data() {
    return {
      // results: this.info,
    };
  },
  computed: {

  }
}
</script>

<style>

</style>